document.addEventListener("DOMContentLoaded", () => {
  const menuBtn = document.querySelector("#menu-btn");
  const body = document.body;
  const nav = document.querySelector("#main-nav");
  const mainContent = document.querySelector("#main-content");
  const siteFooter = document.querySelector("footer");

  // Tailwind's `lg` breakpoint (1024px). Below it #main-nav is an off-canvas
  // panel toggled by menuBtn; at/above it, it's always visible in normal flow.
  const mobileMenuQuery = window.matchMedia("(max-width: 1023px)");

  // Keeps keyboard/screen-reader focus in sync with what's actually visible:
  // - mobile + menu closed  -> nav is off-screen: make it inert (untabbable, hidden from AT)
  // - mobile + menu open    -> nav is a full-screen overlay: make the content it covers inert instead
  // - desktop (>= lg)       -> nav is always visible in flow: never inert
  function syncInert() {
    const isMobileMenuOpen = mobileMenuQuery.matches && body.classList.contains("menu-opened");

    nav.toggleAttribute("inert", mobileMenuQuery.matches && !isMobileMenuOpen);

    if (mainContent) mainContent.toggleAttribute("inert", isMobileMenuOpen);
    if (siteFooter) siteFooter.toggleAttribute("inert", isMobileMenuOpen);
  }

  function closeMenu() {
    body.classList.remove("menu-opened");
    menuBtn.classList.remove("open");
    nav.classList.add("opacity-0", "max-lg:pointer-events-none", "max-lg:-translate-x-full");
    menuBtn.setAttribute("aria-expanded", "false");
    syncInert();
  }

  menuBtn.addEventListener("click", () => {
    body.classList.toggle("menu-opened");
    menuBtn.classList.toggle("open");

    if (body.classList.contains("menu-opened")) {
      nav.classList.remove("opacity-0", "max-lg:pointer-events-none", "max-lg:-translate-x-full");
      menuBtn.setAttribute("aria-expanded", "true");
    } else {
      nav.classList.add("opacity-0", "max-lg:pointer-events-none", "max-lg:-translate-x-full");
      menuBtn.setAttribute("aria-expanded", "false");
    }
    syncInert();
  });

  window.addEventListener("scroll", () => {
    if (body.classList.contains("menu-opened")) {
      closeMenu();
    }
  });

  // Close on Escape and return focus to the toggle button (keyboard operability).
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && body.classList.contains("menu-opened")) {
      closeMenu();
      menuBtn.focus();
    }
  });

  // Re-sync if the viewport crosses the lg breakpoint (resize/orientation change)
  // while the menu happens to be in a non-default state.
  mobileMenuQuery.addEventListener("change", syncInert);

  syncInert();
});